module.exports = __webpack_public_path__ + "img/plan-service-icon3.f32b4bbf.png";